/**
 * This method validates email address
 * @module truncate
 * @param {string} str - a string to truncate
 * @return {string} {String} a truncated string
 * @example
 *
 *  truncate('This is a long string', 10) // returns 'This is a...'
 *
 */
export function truncate(str: string, limit: number = 80): string {
	if (str && str.length > limit) {
		return `${str.substring(0, limit)}${str.length >= limit && '...'}`;
	} else {
		return str;
	}
}
